export enum Currency {
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP",
}
